import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useSurveyData } from '@backrs_ui/grow-ui/src/hooks/useSurveyData';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectSharedBlueprintData } from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedSession';

import { MinimumTrackPage } from './MinimumTrackPage';
import { useAgentContext } from './MinimumTrackPageContainer.agentContext';

type MinimumTrackPageContainerProps = Readonly<{
  isShared?: boolean;
}>;

export function MinimumTrackPageContainer({ isShared = false }: MinimumTrackPageContainerProps) {
  const { isLoadingResponseSet, mostRecentUserResponseSet, surveyResults, careerPath } =
    useSurveyData();

  const sharedBlueprintData = useAppSelector(selectSharedBlueprintData);

  const userHasBlueprint = mostRecentUserResponseSet?.user_responses;

  const filteredTracks = careerPath.careerTracks.filter(
    (track) => track.code !== 'entrepreneurship',
  );
  const selectedTrack =
    isShared && sharedBlueprintData
      ? sharedBlueprintData.tier
      : surveyResults?.tier || 'Semi-skilled';
  const hasBlueprintResolved =
    isShared && sharedBlueprintData
      ? !!sharedBlueprintData.userResponseSet.user_responses
      : !!userHasBlueprint;

  useAgentContext(selectedTrack, filteredTracks, hasBlueprintResolved);

  if (isShared && sharedBlueprintData) {
    return (
      <MinimumTrackPage
        userHasBlueprint={!!sharedBlueprintData.userResponseSet.user_responses}
        userResponseSet={sharedBlueprintData.userResponseSet}
        selectedTrack={sharedBlueprintData.tier}
        careerTracks={filteredTracks}
        isShared={true}
      />
    );
  }

  if (isLoadingResponseSet || careerPath.loading) {
    return <FullScreenLoading />;
  }

  return (
    <MinimumTrackPage
      userHasBlueprint={!!userHasBlueprint}
      userResponseSet={mostRecentUserResponseSet}
      selectedTrack={surveyResults?.tier || 'Semi-skilled'}
      careerTracks={filteredTracks}
      isShared={false}
    />
  );
}
